import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';
import { TJsonApiBody, TJsonApiData, TJsonApiRelationships } from 'jsona/lib/JsonaTypes';
import { PdfImageOverrideConfig } from '@/modules/CMS/interfaces/PdfImageOverride';

export default class ProductSystemPdfImageOverrideAPI {
    public static async getAll() {
        let overrides;
        try {
            overrides = (await ApiController.get(ApiRoutes.productSystemPdfImageOverride.getAll)) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(overrides);
    }

    public static async updateExisting(
        overrideId: string,
        config: PdfImageOverrideConfig,
        pdfOfferImageId: string,
        productSystemId: string,
    ) {
        let override;

        const request: TJsonApiBody = {
            data: {
                type: 'product_system_pdf_image_override',
                id: overrideId,
                attributes: {
                    config,
                },
            },
        };

        const relationships: TJsonApiRelationships = {
            productSystem: {
                data: {
                    type: 'product_systems',
                    id: productSystemId,
                },
            },
            pdfOfferImage: {
                data: {
                    type: 'images',
                    id: pdfOfferImageId,
                },
            },
        };

        if (request.data) {
            (request.data as TJsonApiData).relationships = relationships;
        }

        try {
            override = (await ApiController.patch(
                ApiRoutes.productSystemPdfImageOverride.updateExisting(overrideId),
                request,
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(override);
    }

    public static async createNew(config: PdfImageOverrideConfig, pdfOfferImageId: string, productSystemId: string) {
        let newOverride;

        const request: TJsonApiBody = {
            data: {
                type: 'product_system_pdf_image_override',
                attributes: {
                    config,
                },
            },
        };

        const relationships: TJsonApiRelationships = {
            productSystem: {
                data: {
                    type: 'product_systems',
                    id: productSystemId,
                },
            },
            pdfOfferImage: {
                data: {
                    type: 'images',
                    id: pdfOfferImageId,
                },
            },
        };

        if (request.data) {
            (request.data as TJsonApiData).relationships = relationships;
        }

        try {
            newOverride = (await ApiController.post(
                ApiRoutes.productSystemPdfImageOverride.create,
                request,
            )) as AxiosResponse;
        } catch (e) {
            return Promise.reject(e);
        }

        return Promise.resolve(newOverride);
    }

    public static async deleteExisting(overrideId: string) {
        try {
            await ApiController.delete(ApiRoutes.productSystemPdfImageOverride.deleteExisting(overrideId));
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve();
    }
}
